import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  soldImages: {
    error: {
      isError: false,
      message: '',
    },
    items: {},
    loading: false,
  },
   imageSearchListingData: {
    error: {
      isError: false,
      message: "",
    },
    items: [],
  },
  confirmedOrders: {
    error: {
      isError: false,
      message: '',
    },
    items: {},
    loading: false,
  },

};

export const legalSlice = createSlice({
  name: 'legal',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setSoldImagesListing: (state, action) => {
      state.soldImages.items = action.payload;
      state.soldImages.error = {
        isError: false,
        message: '',
      };
    },
    setSoldImagesListingLoading: (state, action) => {
      state.soldImages.loading = action.payload;
    },
    setSoldImagesListingError: (state, action) => {
      state.soldImages.items = {};
      state.soldImages.error = action.payload;
    },
    setImageSearchError: (state, action) => {
      state.imageSearchListingData.items = {};
      state.imageSearchListingData.error = action.payload;
    },
    setImageSearchData: (state, action) => {
      state.imageSearchListingData.items = action.payload;
      state.imageSearchListingData.error = {
        isError: false,
        message: '',
      };
    },
    setConfirmedOrderListingLoading: (state, action) => {
      state.confirmedOrders.loading = action.payload;
    },
    setConfirmedOrderListing: (state, action) => {
      state.confirmedOrders.items = action.payload;
      state.confirmedOrders.error = {
        isError: false,
        message: '',
      };
    },
    setConfirmedOrderListingError: (state, action) => {
      state.confirmedOrders.items = {};
      state.confirmedOrders.error = action.payload;
    },
  },
});

export default legalSlice.reducer;

export const {
  setLoading,

  setSoldImagesListing,
  setSoldImagesListingError,
  setSoldImagesListingLoading,
  setImageSearchData,
  setImageSearchError,
  setConfirmedOrderListing,
  setConfirmedOrderListingError,
  setConfirmedOrderListingLoading,
 
} = legalSlice.actions;

export const LegalListingItemsSelector = (state) => state.legal;
